import { Expose } from 'class-transformer';

export class SnDiscoveryUrls {
  @Expose()
  public ptzMoveUrls: string;

  @Expose()
  public deviceUrls: string;

  @Expose()
  public ptzInfo: string;

  @Expose()
  public ptzPresetCreate: string;

  @Expose()
  public ptzPresetDelete: string;

  @Expose()
  public ptzPresetList: string;
}
